export const getViteEnvVariable = (name: string, fallback?: string) => {
  const envVariable = import.meta.env[name];

  if (!envVariable && !fallback) {
    throw new Error(`Vite environment variable ${name} has not been set.`);
  }

  return envVariable || fallback;
};

export const EnvConfig = {
  APP_ENV: getViteEnvVariable('VITE_APP'),
  SERVER_PORT: getViteEnvVariable('VITE_SERVER_PORT'),
  CORE_API_CONTEXT: getViteEnvVariable('VITE_CORE_API_CONTEXT'),
  FS_API_CONTEXT: getViteEnvVariable('VITE_FS_API_CONTEXT'),
  SCHEDULER_API_CONTEXT: getViteEnvVariable('VITE_SCHEDULER_API_CONTEXT'),
};
